exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".style_status__1M01p{display:flex;justify-content:center;align-items:center;width:2.25rem;height:2.25rem;border-radius:.125rem;font-size:1.25rem;color:#fff}.style_small__1y0Fs{width:1.25rem;height:1.25rem;font-size:.875rem}.style_Queued__h1K9m{background-color:#215680}.style_Executing__dnX0l{background-color:#0a67b1}.style_Paused__34Pyd,.style_TimedOut__l4mEw{background-color:#fb8c00}.style_Failed__3c1N0{background-color:#db4437}.style_Canceled__37cqN,.style_Cancelling__3c8CE{background-color:#333}.style_Success__2Lz42,.style_SuccessWithWarnings__39_yv{background-color:#53b953}", ""]);

// exports
exports.locals = {
	"status": "style_status__1M01p",
	"small": "style_small__1y0Fs",
	"Queued": "style_Queued__h1K9m",
	"queued": "style_Queued__h1K9m",
	"Executing": "style_Executing__dnX0l",
	"executing": "style_Executing__dnX0l",
	"Paused": "style_Paused__34Pyd",
	"paused": "style_Paused__34Pyd",
	"TimedOut": "style_TimedOut__l4mEw",
	"timedOut": "style_TimedOut__l4mEw",
	"Failed": "style_Failed__3c1N0",
	"failed": "style_Failed__3c1N0",
	"Canceled": "style_Canceled__37cqN",
	"canceled": "style_Canceled__37cqN",
	"Cancelling": "style_Cancelling__3c8CE",
	"cancelling": "style_Cancelling__3c8CE",
	"Success": "style_Success__2Lz42",
	"success": "style_Success__2Lz42",
	"SuccessWithWarnings": "style_SuccessWithWarnings__39_yv",
	"successWithWarnings": "style_SuccessWithWarnings__39_yv"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!./node_modules/less-loader/dist/cjs.js!./app/areas/projects/components/TaskStatusIcon/style.less
// module id = 1459
// module chunks = 8